
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Contact() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-teal-600 to-teal-700 text-white py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: 'Barlow, sans-serif' }}>
                Contact Stiletto Airpark
              </h1>
              <p className="text-xl text-teal-100 max-w-3xl mx-auto">
                Ready to start your flight training journey? Get in touch with our experienced team in Central Texas.
              </p>
            </div>
          </div>
        </section>

        {/* Contact Information */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              
              {/* Contact Details */}
              <div className="space-y-8">
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-8" style={{ fontFamily: 'Barlow, sans-serif' }}>
                    Get In Touch
                  </h2>
                  <p className="text-lg text-gray-600 mb-8">
                    Located in the heart of Central Texas, Stiletto Airpark is your premier destination for professional flight training. We're here to help you achieve your aviation goals.
                  </p>
                </div>

                {/* Contact Info Cards */}
                <div className="space-y-6">
                  {/* Phone */}
                  <div className="flex items-start space-x-4 p-6 bg-gray-50 rounded-lg">
                    <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Phone</h3>
                      <a 
                        href="tel:706-936-8961" 
                        className="text-teal-600 hover:text-teal-700 text-lg font-medium cursor-pointer"
                      >
                        706-936-8961
                      </a>
                      <p className="text-gray-600 text-sm mt-1">Call us for immediate assistance</p>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="flex items-start space-x-4 p-6 bg-gray-50 rounded-lg">
                    <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Email</h3>
                      <a 
                        href="mailto:stiletto1@stilettoaircraft.com" 
                        className="text-teal-600 hover:text-teal-700 text-lg font-medium cursor-pointer"
                      >
                        stiletto1@stilettoaircraft.com
                      </a>
                      <p className="text-gray-600 text-sm mt-1">Send us your questions anytime</p>
                    </div>
                  </div>

                  {/* Address */}
                  <div className="flex items-start space-x-4 p-6 bg-gray-50 rounded-lg">
                    <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Location</h3>
                      <p className="text-gray-900 text-lg font-medium">Stiletto Airpark (XS79)</p>
                      <p className="text-gray-600">Bertram, Texas 78605</p>
                      <p className="text-gray-600 text-sm mt-1">Central Texas - Serving Austin, DFW, and surrounding areas</p>
                    </div>
                  </div>
                </div>

                {/* Service Areas */}
                <div className="bg-teal-50 p-6 rounded-lg">
                  <h3 className="text-xl font-semibold text-gray-900 mb-4" style={{ fontFamily: 'Barlow, sans-serif' }}>
                    Service Areas
                  </h3>
                  <div className="grid grid-cols-2 gap-2 text-gray-700">
                    <div className="flex items-center">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      <span>Austin</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      <span>Round Rock</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      <span>Cedar Park</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      <span>Leander</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      <span>Temple</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      <span>Killeen</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      <span>San Marcos</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      <span>DFW Area</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Google Maps */}
              <div className="lg:sticky lg:top-8">
                <div className="bg-gray-100 rounded-lg overflow-hidden shadow-lg">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.123456789!2d-97.9428!3d30.7431!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sBertram%2C%20TX%2078605!5e0!3m2!1sen!2sus!4v1234567890"
                    width="100%"
                    height="400"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Stiletto Airpark Location"
                  ></iframe>
                </div>
                
                <div className="mt-6 p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Directions</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Stiletto Airpark is conveniently located in Bertram, Texas, just 30 miles northwest of Austin. 
                    We're easily accessible from major highways and serve pilots throughout Central Texas.
                  </p>
                  <div className="mt-4">
                    <a 
                      href="https://maps.google.com/?q=Bertram,TX+78605" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-teal-600 hover:text-teal-700 font-medium cursor-pointer"
                    >
                      <i className="ri-external-link-line mr-2"></i>
                      Get Directions
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="bg-gray-50 py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Barlow, sans-serif' }}>
              Ready to Start Your Flight Training?
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Contact us today to discuss your aviation goals and schedule your first lesson at Stiletto Airpark.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:706-936-8961" 
                className="bg-teal-600 text-white px-8 py-3 rounded-md text-lg font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Call Now: 706-936-8961
              </a>
              <a 
                href="mailto:stiletto1@stilettoaircraft.com" 
                className="bg-white text-teal-600 border-2 border-teal-600 px-8 py-3 rounded-md text-lg font-medium hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Send Email
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
